document.addEventListener('DOMContentLoaded', function () {
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  const urlParams = new URLSearchParams(window.location.search);
  const marketCapType =
    urlParams.get('option') || getCookie('option') || 'large';
  const exchangeType =
    urlParams.get('exchange') || getCookie('exchange') || 'nse';
  const currentLimit = parseInt(urlParams.get('limit')) || 10;

  const nseATag = document.getElementById('nse-a-tag');
  const bseATag = document.getElementById('bse-a-tag');
  const sizeSelect = document.getElementById('mcap');

  const viewMoreButton = document.getElementById('view-more-btn');
  if (viewMoreButton) {
    viewMoreButton.addEventListener('click', function () {
      let currentLimitSMT = viewMoreButton.getAttribute('data-limit');
      currentLimitSMT = parseInt(currentLimitSMT, 10);
      let defaultLimitSMT = viewMoreButton.getAttribute('data-default-limit');
      defaultLimitSMT = parseInt(defaultLimitSMT, 10);
      let newLimit;
      if (
        isNaN(currentLimitSMT) ||
        currentLimitSMT === null ||
        isNaN(defaultLimitSMT) ||
        defaultLimitSMT === null
      ) {
        newLimit = currentLimit + 10;
      } else {
        newLimit = currentLimitSMT + defaultLimitSMT;
      }
      document.cookie = `limit=${newLimit}; path=/;`;
      const newUrl = window.location.pathname;
      window.history.pushState({}, '', newUrl);
      window.location.reload();
    });
  }

  if (sizeSelect) {
    sizeSelect.value = marketCapType;

    sizeSelect.addEventListener('change', function () {
      const selectedSize = sizeSelect.value;
      document.cookie = `option=${selectedSize}; path=/;`;
      window.location.reload();
    });
  }

  const largeBtn = document.getElementById('large');
  const midBtn = document.getElementById('mid');
  const smallBtn = document.getElementById('small');

  const handleMobileSelection = function (selectedButton) {
    largeBtn.classList.remove('active');
    midBtn.classList.remove('active');
    smallBtn.classList.remove('active');

    selectedButton.classList.add('active');
    const selectedValue = selectedButton.id;
    document.cookie = `option=${selectedValue}; path=/;`;
    window.location.reload();
  };

  if (largeBtn && midBtn && smallBtn) {
    largeBtn.addEventListener('click', function () {
      handleMobileSelection(largeBtn);
    });
    midBtn.addEventListener('click', function () {
      handleMobileSelection(midBtn);
    });
    smallBtn.addEventListener('click', function () {
      handleMobileSelection(smallBtn);
    });

    if (marketCapType === 'large') {
      largeBtn.classList.add('active');
    } else if (marketCapType === 'mid') {
      midBtn.classList.add('active');
    } else if (marketCapType === 'small') {
      smallBtn.classList.add('active');
    }
  }

  function handleExchangeChange(exchange) {
    const currentUrl = window.location.pathname;

    if (
      currentUrl.includes('gainers') ||
      currentUrl.includes('losers') ||
      currentUrl.includes('volume') ||
      currentUrl.includes('value')
    ) {
      const newUrl = currentUrl.replace(/(nse|bse)/, exchange);
      document.cookie = `exchange=${exchange}; path=/;`;
      window.location.href = newUrl;
    } else {
      document.cookie = `exchange=${exchange}; path=/;`;
      window.location.reload();
    }
  }

  if (nseATag && bseATag) {
    nseATag.addEventListener('click', function (event) {
      event.preventDefault();
      handleExchangeChange('nse');
    });

    bseATag.addEventListener('click', function (event) {
      event.preventDefault();
      handleExchangeChange('bse');
    });
  }

  if (exchangeType === 'nse' && nseATag && bseATag) {
    bseATag.classList.remove('active');
    nseATag.classList.add('active');
  } else if (exchangeType === 'bse' && nseATag && bseATag) {
    nseATag.classList.remove('active');
    bseATag.classList.add('active');
  }

  document.cookie = `exchange=${exchangeType}; path=/;`;
  document.cookie = `option=${marketCapType}; path=/;`;

  const activeTab = document.querySelector('.tab--part a.active');

  if (activeTab) {
    activeTab.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'start',
    });
  }

  function performSearch(query) {
    const apiUrl = `${window._Torus.BFF_BASE_URL}/etf/master/search?company_name=${query.toLowerCase()}`;

    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        const resultsContainer = document.getElementById('searchResults');
        resultsContainer.innerHTML = '';

        if (data && data.length > 0) {
          data.forEach((item) => {
            if (item.ETFName && item.CompanySlug) {
              const resultItem = document.createElement('a');
              resultItem.textContent = item.ETFName;
              resultItem.href = `${window.location.origin}/etf/${item.CompanySlug}`;
              resultItem.target = '_blank';
              resultItem.addEventListener('click', (event) => {
                event.preventDefault();
                window.open(resultItem.href, '_blank');
              });
              resultsContainer.appendChild(resultItem);
            }
          });
          resultsContainer.style.display = 'block';
        } else {
          resultsContainer.innerHTML = '<p>No results found</p>';
          resultsContainer.style.display = 'block';
        }
      })
      .catch((error) => {
        console.error('Error fetching search results:', error);
      });
  }

  function filterSectors() {
    const searchTerm = document
      .getElementById('searchInput')
      .value.trim()
      .toLowerCase();
    if (searchTerm !== '') {
      performSearch(searchTerm);
    } else {
      document.getElementById('searchResults').style.display = 'none';
    }
  }

  const searchInput = document.getElementById('searchInput');
  const resultsContainer = document.getElementById('searchResults');
  if (searchInput && resultsContainer) {
    searchInput.addEventListener('input', filterSectors);

    document.addEventListener('click', (event) => {
      if (
        !searchInput.contains(event.target) &&
        !resultsContainer.contains(event.target)
      ) {
        resultsContainer.style.display = 'none';
        searchInput.value = '';
      }
    });
  }
});
